import { IBasicRightResults } from "UI/UI/Rights/BasicRightsResults";
import { IClassItemRights } from "../../../OW.Remoting/Remoting/Rights";
import { IRightTypeEvaluationFunction } from "./IRightsEvaluationOverrides";
import { IUseMasterObject } from "./IUseMasterObject";
import { IItemRightsCollection } from "./RightTypes";

export interface ILogicalComponentBase<TRightType, TInnerComponent, TComponentType> extends IUseMasterObject {
    /**
     * Element komponenta
     */
    readonly control: TInnerComponent;
    /**
     * Nadřízený wrapper komponenty
     */
    readonly parentControlWrapper: ILogicalComponentBase<TRightType, TInnerComponent, TComponentType>;

    /**
     * Název atributu komponenty
     */
    readonly attrName: string;
    /**
     * Název metody
     */
    readonly methodName: string;
    /**
     * Typ komponenty (atribut/metoda)
     */
    readonly componentType: TComponentType | null;
    /**
     * Zda se nad touto komponentou nemají vyhodnocovat práva
     */
    readonly rightsIgnored: boolean;
    /**
     * Podmínka komponenty
     */
    readonly condition: string;

    /**
     * Pokud jde o statickou kompoentu
     */
    readonly isStatic: boolean | null;

    /**
     * Zda již nevyhodnocovat práva na potomcích
     */
    readonly stopRightsEvaluatingOnChildren?: boolean;

    readonly rightsCollection: IItemRightsCollection;
    /**
     * Uchovaná serverová práva položky z posledního vyhodnocení
     */
    classItemRights: IClassItemRights | null;

    /**
     * Příznak, že nejde o skutečnou komponentu, ale jen o pomocnou (např. pro účely hierarchie stromu)
     */
    readonly isVirtualControl?: boolean;

    rightsEvaluationOverrides: IRightTypeEvaluationFunction<TRightType, ILogicalComponentBase<TRightType, TInnerComponent, TComponentType>, boolean | null, IBasicRightResults>[];

    getRight(rightType: TRightType): boolean | null;

    setRight(rightType: TRightType, value: boolean): boolean;
}
